// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServiceCategories_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/service_categories/get/{id}
 *
 * Single service-category row. Wire shape: `dados: ServiceCategories_GetRow`.
 */
import type { ServiceCategories_GetRow } from './ServiceCategories_GetRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServiceCategories_GetResponseDados = ServiceCategories_GetRow;

export type ServiceCategories_GetResponse = ApiResponse<ServiceCategories_GetResponseDados>;

registerResponseContract('ServiceCategories_GetResponse', {
  so_service_category_id:         { type: 'number',  required: true },
  so_service_category_name:       { type: 'string',  required: true },
  so_service_category_icon_svg:   { type: 'string',  required: false },
  so_service_category_active:     { type: 'number',  required: true },
  so_service_category_created_at: { type: 'string',  required: false },
})
